import { Box, Container, Typography } from '@mui/material';
import { useAuth } from '../auth/auth-hook';
import { useSearchParams } from 'react-router-dom';
import { EventAfterBuy } from '../plan/components/EventAfterBuy';
import { APP_ENDPOINT } from '../../shared/constans';

export const SubAppreciation: React.FC = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('sub-type') || '';
  if (!['student-sub', 'monthly-sub', 'yearly-sub'].includes(query)) {
    return null;
  }
  if (!user || !query) {
    return null;
  }
  let subType = '';
  let subImage = '';
  let subLink = '';
  switch (query) {
    case 'student-sub':
      subType = 'suscripción estudiantil';
      subImage =
        'https://digitalroom.nyc3.cdn.digitaloceanspaces.com/animal-politico-mails/sub-student-icon.png';
      subLink = `${APP_ENDPOINT}/?utm_source=newsletter&utm_medium=email&utm_campaign=bienvenida_estudiantil`;
      break;
    case 'monthly-sub':
      subType = 'suscripción mensual';
      subImage =
        'https://digitalroom.nyc3.cdn.digitaloceanspaces.com/animal-politico-mails/sub-montly-icon.png';
      subLink = `${APP_ENDPOINT}/?utm_source=newsletter&utm_medium=email&utm_campaign=bienvenida_mensual`;
      break;
    case 'yearly-sub':
      subType = 'suscripción anual';
      subImage =
        'https://digitalroom.nyc3.cdn.digitaloceanspaces.com/animal-politico-mails/sub-anual-icon.png';
      subLink = `${APP_ENDPOINT}/?utm_source=newsletter&utm_medium=email&utm_campaign=bienvenida_anual'`;
      break;
  }
  if (!subType || !subImage || !subLink) {
    return null;
  }
  return (
    <div>
      {user ? <EventAfterBuy type={query} user={user} /> : null}
      <Box paddingY={5}>
        <Container maxWidth={'sm'}>
          <Box
            display={'flex'}
            justifyContent={'center'}
            paddingX={2}
            marginBottom={'40px'}
          >
            <div>
              <Typography
                fontFamily={'oswald'}
                fontWeight={700}
                fontSize={28}
                lineHeight={'33px'}
              >
                ¡BIENVENID@ A
              </Typography>
              <Typography
                fontFamily={'oswald'}
                fontSize={28}
                fontWeight={700}
                color={'#FC1206'}
                lineHeight={'33px'}
              >
                GRUPO ANIMAL!
              </Typography>
            </div>
          </Box>
          <Box
            sx={{ background: '#f0f0f0' }}
            paddingX={{ xs: '10px', lg: '30px' }}
            paddingY={{ xs: '45px', lg: '30px' }}
            marginBottom={'34px'}
            position={'relative'}
          >
            <Box
              component={'img'}
              height={'84px'}
              width={'84px'}
              position={'absolute'}
              top={-42}
              right={20}
              src={subImage}
              alt="tipo de suscripción"
            />
            <Typography
              fontFamily={'oswald'}
              textTransform={'uppercase'}
              fontSize={28}
              color={'#FC1206'}
              lineHeight={'33px'}
            >
              Hola, {user.name}
            </Typography>
            <Box paddingTop={2}>
              <Typography fontFamily={'manop'}>
                Gracias por sumarte a Grupo Animal
                <br />
                <br />
              </Typography>
              <Typography fontFamily={'manop'}>
                El pago de tu{' '}
                <span style={{ color: '#FF393F', fontWeight: 700 }}>
                  {subType}
                </span>{' '}
                se ha procesado correctamente.
                <br />
                <br />
              </Typography>
              <Typography fontFamily={'manop'}>
                Tu aporte económico nos ayudará a seguir financiando el
                periodismo libre e independiente en el que creemos.
              </Typography>
              {query === 'yearly-sub' && (
                <Typography fontFamily={'manop'}>
                  <br />
                  En los próximos minutos un asesor personalizado te contactará
                  vía WhatsApp para coordinar el envío de tu kit de bienvenida.
                </Typography>
              )}
            </Box>
          </Box>
          <Box display={'flex'} justifyContent={'center'}>
            <a href={subLink} style={{ textDecoration: 'none' }}>
              <Box
                paddingX={'22px'}
                paddingY={'16px'}
                borderRadius={'33px'}
                sx={{ background: '#FC1206' }}
              >
                <Typography
                  fontFamily={'oswald'}
                  lineHeight={'16px'}
                  color={'white'}
                  textTransform={'uppercase'}
                >
                  Lee nuestros contenidos
                </Typography>
              </Box>
            </a>
          </Box>
        </Container>
      </Box>
    </div>
  );
};
